module.exports = __webpack_public_path__ + "static/SM_CaseIT-2022_ENG-b09649446ba854ec29d56acd9c45c605.pdf";